import { makeStyles } from '@fluentui/react-components';

export const useMenuButtonStyles = makeStyles({
  menuButton: {
    alignItems: 'flex-start',
    '& .fui-MenuButton__menuIcon': {
      fontSize: '15px',
    },
  },
  menuPopover: {
    minWidth: 'fit-content',
  },
});
